import _classCallCheck from "/Users/neelrao/Projects/citycraft/client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import B from '../binary/BinaryType';

var NoInterpsMessage = function NoInterpsMessage(ids) {
  _classCallCheck(this, NoInterpsMessage);

  this.type = 66;
  this.ids = ids;
};

NoInterpsMessage.protocol = {
  ids: {
    type: B.UInt32,
    indexType: B.UInt32
  }
};
export default NoInterpsMessage;